import React from "react";
import DocumentNavbar from "./DocumentNavbar";

function DocumentManagerHome() {
    return(
        <>
        <DocumentNavbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Document Manager Home</h2>
        </div>
        </>
    );
}
export default DocumentManagerHome;